import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Tooltip } from '@mui/material';
import { FC } from 'react';

type DeleteRowButtonProps = {
  onDeleteActionHandler: (row: unknown) => void;
  title?: string;
};

export const DeleteRowButton: FC<DeleteRowButtonProps> = ({ onDeleteActionHandler, title = '' }) => (
  <Tooltip placement="top" title={title}>
    <Button
      key="delete-button"
      onClick={onDeleteActionHandler}
      variant="contained"
      color="error"
      size="small"
      sx={{ width: '35px', minWidth: '35px', height: '31px' }}
    >
      <DeleteIcon fontSize="small" />
    </Button>
  </Tooltip>
);
